import React from "react";
import { Button, ButtonGroup, Row} from "react-bootstrap";
import { useSourceReducer } from "../../../sourceContext";
import '../../../../../assets/css/components/multiselectButtonControls.css'
import { useControlReducer } from "../../../controlContext";
import { AddItemModal } from "./modalAddItem";
import { AddExistingItemModal } from "./modalAddExisting";
import { EditAllModal } from "./modalEditAllItems";
import { langTypeMap } from "../../../../../shared/Data/langTypeMap";


const rowClass = 'button-row'


export function ButtonControls({setDisplayKeys, displayKeys, viewMode, setViewMode, name, value, idx}){
  // const source = useSource()
  const controlsReducer = useControlReducer()
  const sourceReducer = useSourceReducer()
  return (
    <>
      <Row className={rowClass}>
        <ButtonGroup>
          <ToggleButton 
              toggleVal={viewMode}
              onClick={setViewMode}
              texts={['View Mode: Relative', 'View Mode: All']}
          />
        </ButtonGroup>
      </Row>
      <Row className={rowClass}>
        <AddItemModal name={name} />
        <Button onClick={()=>{
          if(value){
            console.log('executing delete', name, value)
            let child_types = [name]
            let child_chain = []
            while(child_types.length){
              child_chain = [...child_chain, ...child_types] 
              child_types = child_types.reduce((prev, current)=>{
                return [...prev, ...langTypeMap[current].getChildTypes()]
              }, [])
            }
            controlsReducer({type: 'clear_by_keys', keys:child_chain, idx })
            setTimeout(()=>sourceReducer({type:'delete_item', itemId:value, typeDir:name, idx}))
          }
        }}>
          Delete Selected Item
        </Button>
        
      </Row>
      <Row className={rowClass}>
        <AddExistingItemModal name={name} idx={idx} />
        <EditAllModal name={name} />
      </Row>
    </>
  )

}



function ToggleButton({texts, toggleVal, onClick}){
  return (
    <Button 
      variant={`${(!toggleVal?'outline-':'') + 'info'}`} 
      onClick={()=>onClick(!toggleVal)}  
    >
      {!toggleVal?texts[0]:texts[1]}
    </Button>
  )
}